import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import netlifyIdentity from "netlify-identity-widget";
import "./members.css";

// To add a video: copy the ID from the YouTube URL (the part after youtu.be/ or v=)
// and add a new { id: 'VIDEO_ID', title: 'Video Title' } entry below.
const PLAYLISTS = [
  {
    title: "Setting Development Goals",
    videos: [
      { id: "MUNwWl82Aws", title: "1. Goal as Behaviour" },
      { id: "z6ZBcUoU_0Q", title: "2. SMART Goal" },
      { id: "sjPty-ppq4g", title: "3. Using the Plan" },
      { id: "5-yGIt3QJ5A", title: "4. Goal as Attitude" },
      { id: "VFhrNgLK2Ag", title: "5. Resistance to Change" },
      // To add more videos, add another object here:
      // { id: 'VIDEO_ID', title: 'Video Title' },
    ],
  },
];

function Members() {
  const [user, setUser] = useState(() => netlifyIdentity.currentUser());

  useEffect(() => {
    const handleLogin = (nextUser) => {
      setUser(nextUser);
      netlifyIdentity.close();
    };
    const handleLogout = () => setUser(null);

    netlifyIdentity.on("login", handleLogin);
    netlifyIdentity.on("logout", handleLogout);

    return () => {
      netlifyIdentity.off("login", handleLogin);
      netlifyIdentity.off("logout", handleLogout);
    };
  }, []);

  if (!user) {
    return (
      <section className="members__prompt">
        <Container>
          <h1 className="members__title">Members Area</h1>
          <p className="members__subtitle">
            This area is for Alight Coaching clients. Please log in to access your
            content.
          </p>
          <button
            type="button"
            className="members__button"
            onClick={() => netlifyIdentity.open()}
          >
            Log In
          </button>
        </Container>
      </section>
    );
  }

  return (
    <>
      <section className="members__header">
        <Container>
          <h1 className="members__title">Members Area</h1>
          <p className="members__subtitle">
            Welcome back. Your coaching playlists are below.
          </p>
          <Link to="/members/dashboard" className="members__dashboard-link">
            View your Coaching Dashboard
          </Link>
          <button
            type="button"
            className="members__logout"
            onClick={() => netlifyIdentity.logout()}
          >
            Log Out
          </button>
        </Container>
      </section>

      <section className="members__section">
        <Container>
          {PLAYLISTS.map((playlist) => (
            <div className="members__playlist" key={playlist.title}>
              <h2 className="members__heading">{playlist.title}</h2>
              <div className="members__video-grid">
                {playlist.videos.map((video) => (
                  <div className="members__video" key={video.id}>
                    <h3 className="members__video-title">{video.title}</h3>
                    <div className="members__video-wrapper">
                      <iframe
                        src={`https://www.youtube.com/embed/${video.id}`}
                        title={video.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        loading="lazy"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </Container>
      </section>
    </>
  );
}

export default Members;
